import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { AuthGuardService } from "src/helpers/auth-guard.service";
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { RoleGuardService } from "src/helpers/role-guard.service";

const routes: Routes = [
  {
    path: 'login',
    
    loadChildren: 'src/presentation/features/login/login.module#LoginModule'
  },
  {
    path: 'users',
    loadChildren: 'src/presentation/features/user/user.module#UserModule',
    data: {role: 'ADMIN'},
    canActivate: [AuthGuardService,RoleGuardService],
  },
  {
    path: 'practise',
    loadChildren: 'src/presentation/features/practise/practise.module#PractiseModule',
    canActivate: [AuthGuardService],
  },
  {
    path: 'mock',
    loadChildren: 'src/presentation/features/mock/mock.module#MockModule',
    canActivate: [AuthGuardService],
  },
  {
    path: 'questions',
    loadChildren: 'src/presentation/features/questions/questions.module#QuestionsModule',
    data: {role: 'ADMIN'},
    canActivate: [AuthGuardService,RoleGuardService],
  },
  {
    path: 'languages',
    loadChildren: 'src/presentation/features/languages/languages.module#LanguagesModule',
    data: {role: 'ADMIN'},
    canActivate: [AuthGuardService,RoleGuardService],
  },
  {
    path: 'branches',
    loadChildren: 'src/presentation/features/branches/branches.module#BranchesModule',
    data: {role: 'ADMIN'},
    canActivate: [AuthGuardService,RoleGuardService],
  },
  {
    path: 'packages',
    loadChildren: 'src/presentation/features/packages/packages.module#PackagesModule',
    data: {role: 'ADMIN'},
    canActivate: [AuthGuardService,RoleGuardService],
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '404', component: PagenotfoundComponent },
  { path: '**', component: PagenotfoundComponent }
];

const config: ExtraOptions = {
  useHash: true,
  enableTracing: false // Turn this on to log routing events to the console
  // ,preloadingStrategy: PreloadAllModules
};

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
